/**
 * 🤖 AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * This file is automatically generated by vite-plugins/markdown-routes.ts
 * Source: content/blog/drafts/rfa-product-engineering.md
 *
 * ⚠️ Any manual changes will be overwritten on next build.
 *
 * To modify this blog post:
 * 1. Edit the source markdown file: content/blog/drafts/rfa-product-engineering.md
 * 2. Run the build process to regenerate this file
 */

import { createFileRoute } from '@tanstack/react-router';
import { ArticleLayout } from '@/components/ArticleLayout';
import { createArticleMeta } from '@/lib/meta';
import Content from '@/content/rfa-product-engineering.mdx';

const metadata = {
  slug: "rfa-product-engineering",
  title: "RFA: Product Engineering Role/Title",
  author: "Christian Battaglia",
  description: "A request for approval of the \"product engineer\" role — where the lines between technology, art, and science blur and the definition becomes beautifully recursive.\n",
  authorImage: "/assets-cdbattaglia/media/images/chris_profile.svg",
  
  date: "2019-12-20T00:00:00.000Z",
  
  readTime: "1 min read",
  tags: ["product engineering","career","engineering roles","technology","software engineering","Amplify","product management","engineering leadership"],
};

export const Route = createFileRoute('/blog/posts/rfa-product-engineering')({
  component: ArticlePage,
  head: () => createArticleMeta({
    title: `${metadata.title}${metadata.author ? ` - ${metadata.author}` : ''}`,
    description: metadata.description || '',
    path: '/blog/posts/rfa-product-engineering',
    image: '/og/blog/rfa-product-engineering.png',
    imageAlt: metadata.title,
    datePublished: metadata.date,
    dateModified: undefined,
    authorName: metadata.author,
    tags: metadata.tags,
    readTime: metadata.readTime,
    section: 'Blog',
  }),
});

function ArticlePage() {
  return (
    <ArticleLayout {...metadata}>
      <Content />
    </ArticleLayout>
  );
}
